var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsf-control ds-teas-unite-nav-menu-setting mobile" },
    [
      _vm.scriptLoaded
        ? _c(
            "header",
            [
              _vm._m(0),
              _c(
                "draggable",
                _vm._b(
                  {
                    ref: "menus",
                    staticClass: "group-content",
                    model: {
                      value: _vm.selectMenus,
                      callback: function ($$v) {
                        _vm.selectMenus = $$v
                      },
                      expression: "selectMenus",
                    },
                  },
                  "draggable",
                  _vm.options,
                  false
                ),
                [
                  _vm._l(_vm.selectMenus, function (menu) {
                    return [
                      _c(
                        "div",
                        {
                          key: menu._id,
                          staticClass: "menu-item",
                          attrs: { "data-id": menu._id },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "menu-item-box" },
                            [
                              _c("van-image", {
                                attrs: {
                                  src: _vm._f("imgFormat")(menu.picture),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "error",
                                      fn: function () {
                                        return [
                                          _c("i", {
                                            staticClass: "iconfont",
                                            class: [menu.icon],
                                            style: { color: menu.color },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "menu-item-name ds-multi-ellipsis-1",
                                },
                                [_vm._v(" " + _vm._s(menu.name) + " ")]
                              ),
                              _c("i", {
                                staticClass:
                                  "menu-item-bt iconfont icon-shanchu1",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.remove(menu)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _c("van-divider", [_vm._v("点击下方按钮，可添加菜单到我的应用")]),
      _c(
        "main",
        [
          !_vm.menuList.length
            ? _c("div", { staticClass: "no-data" }, [_vm._v("暂时还没有数据~")])
            : _vm._e(),
          _vm._l(_vm.menuList, function (group1) {
            return [
              group1.children && group1.children.length > 0
                ? _c("div", { key: group1._id, staticClass: "group" }, [
                    _c("div", { staticClass: "group-title" }, [
                      _c("span", [_vm._v(_vm._s(group1.name))]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "group-content" },
                      [
                        _vm._l(group1.children, function (group2) {
                          return [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.checkList.indexOf(group2._id) === -1,
                                    expression:
                                      "checkList.indexOf(group2._id) === -1",
                                  },
                                ],
                                key: group2._id,
                                staticClass: "menu-item",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "menu-item-box",
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectChange(group2)
                                      },
                                    },
                                  },
                                  [
                                    _c("van-image", {
                                      attrs: {
                                        src: _vm._f("imgFormat")(
                                          group2.picture
                                        ),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "error",
                                            fn: function () {
                                              return [
                                                _c("i", {
                                                  staticClass: "iconfont",
                                                  class: [group2.icon],
                                                  style: {
                                                    color: group2.color,
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "menu-item-name ds-multi-ellipsis-1",
                                      },
                                      [_vm._v(" " + _vm._s(group2.name) + " ")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._l(group2.children, function (menu) {
                              return [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.checkList.indexOf(menu._id) ===
                                          -1,
                                        expression:
                                          "checkList.indexOf(menu._id) === -1",
                                      },
                                    ],
                                    key: menu._id,
                                    staticClass: "menu-item",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "menu-item-box",
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectChange(menu)
                                          },
                                        },
                                      },
                                      [
                                        _c("van-image", {
                                          attrs: {
                                            src: _vm._f("imgFormat")(
                                              menu.picture
                                            ),
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "error",
                                                fn: function () {
                                                  return [
                                                    _c("i", {
                                                      staticClass: "iconfont",
                                                      class: [menu.icon],
                                                      style: {
                                                        color: menu.color,
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "menu-item-name ds-multi-ellipsis-1",
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(menu.name) + " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("我的应用")]),
      _c("span", [_vm._v("拖动可调整应用位置与排序")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }